module.exports = __webpack_public_path__ + "static/media/YF70_1.0f39d4be.jpg";